<template>
	<div ref="topBarRef" class="reservation-bar">
		<nuxt-link :to="localePath('/')" class="reservation-bar__space">
			<GlobalIcon name="carfree-logo" :width="94" :height="47" />
		</nuxt-link>
		<div ref="topNodesContainerRef" class="reservation-bar__nav">
			<ReservationTopBarNode
				v-for="(point, i) in topBarData"
				ref="topNodes"
				:key="i"
				:title="i18nService.$tDynamic('modules.reservation_module.reservation.top_bar.data', point.title)"
				:done="point.done"
				:active="point.active"
				:last="point.last"
				:i="i"
				@click="goToStep(i, point)" />
		</div>
		<div class="reservation-bar__space"></div>
	</div>
</template>

<script setup lang="ts">
const topBarData = inject<Ref<any[]>>('topBarData')!
const topBarRef = ref<HTMLElement | null>()
const reservationTopBarHeight = inject<Ref<number>>('reservationTopBarHeight')!
const router = useRouter()
const topNodes = ref<any[]>([])
const topNodesContainerRef = ref<HTMLElement | null>()
const localePath = useLocalePath()
const i18nService = usei18nService()

const resizeObserver = ref<ResizeObserver | null>(null)

onMounted(() => {
	if (topBarRef.value) {
		reservationTopBarHeight.value = topBarRef.value.clientHeight
		resizeObserver.value = new ResizeObserver((entries) => {
			reservationTopBarHeight.value = entries[0].contentRect.height
		})
		resizeObserver.value.observe(topBarRef.value)
	}
})

onBeforeUnmount(() => {
	resizeObserver.value?.disconnect()
})

const step = inject<Ref<number>>('step')!

const goToStep = (index: number, point: any) => {
	if (point.url) {
		step.value = 0
		router.push(localePath(point.url))
	} else if (index < step.value) step.value = index
}

watch(
	() => step.value,
	async () => {
		await nextTick()
		if (topNodes.value[step.value]) {
			const topNodesContainer = topNodesContainerRef.value
			const topNode = topNodes.value[step.value].$el

			requestAnimationFrame(() => {
				const topNodeOffset = topNode.offsetLeft
				if (topNodesContainer) {
					topNodesContainer.scrollTo({
						left: topNodeOffset - 16,
						behavior: 'smooth',
					})
				}
			})
		}
	},
)
</script>

<style lang="scss" scoped src="./TopBar.scss"></style>
